import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

@autoinject
export class DecimalHoursToHourMinuteValueConverter {
  constructor(private t: I18N) {}

  toView(time?: number | string | null): string | null {
    if (time === null || time === undefined) {
      return null;
    }

    time = +time; // Ensure value is a number

    if (isNaN(time)) {
      return null;
    }

    time = Math.max(time, 0);

    const hours = Math.floor(time);
    const minutes = Math.round((time - hours) * 60);

    const hourLabel = hours == 1 ? this.t.tr('general.hour') : this.t.tr('general.hour_plural');
    const minuteLabel = minutes == 1 ? this.t.tr('general.minute') : this.t.tr('general.minute_plural');

    return `${hours} ${hourLabel}, ${minutes} ${minuteLabel}`;
  }
}
